import { ButtonType } from '@/components/custom/arito/custom-input-table/types';

export const buttonConfigs: Record<ButtonType, { icon: number; title: string }> = {
  add: { icon: 7, title: 'Thêm dòng mới' },
  delete: { icon: 8, title: 'Xóa dòng đã chọn' },
  copy: { icon: 11, title: 'Sao chép dòng' },
  paste: { icon: 4, title: 'Dán vào dòng' },
  moveUp: { icon: 3, title: 'Di chuyển lên' },
  moveDown: { icon: 30, title: 'Di chuyển xuống' },
  pin: { icon: 16, title: 'Cố định cột' },
  export: { icon: 18, title: 'Kết xuất dữ liệu' },
  downloadExcel: { icon: 28, title: 'Tải mẫu Excel' },
  uploadExcel: { icon: 29, title: 'Lấy dữ liệu từ Excel' },
  refresh: { icon: 15, title: 'Làm mới' },
  detail: { icon: 770, title: 'Tổng hợp chi tiết' },
  edit: { icon: 864, title: 'Chỉnh sửa' },
  viewInventory: { icon: 553, title: 'Xem tồn kho' },
  viewReceipt: { icon: 140, title: 'Xem phiếu nhập' },
  saveAllocation: { icon: 294, title: 'Lưu phân bổ' },
  deleteAllocation: { icon: 8, title: 'Xóa phân bổ' },
  watch: { icon: 19, title: 'Xem' }
};
